/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Jump_DayInputs */

const en_plan_jump_day = /** @type {(inputs: Plan_Jump_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to day`)
};

const de_plan_jump_day = /** @type {(inputs: Plan_Jump_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Tag springen`)
};

/**
* | output |
* | --- |
* | "Jump to day" |
*
* @param {Plan_Jump_DayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_jump_day = /** @type {((inputs?: Plan_Jump_DayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Jump_DayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_jump_day(inputs)
	return en_plan_jump_day(inputs)
});